import { useEffect } from 'react'

interface Props {
  message: string
  /**
   * What kind of message this is. A refusal in the same green as a successful
   * save reads as "done" at a glance, which is the opposite of what it says.
   */
  tone?: 'ok' | 'warn'
  onDone: () => void
}

/**
 * Says a save went through, then gets out of the way.
 *
 * A waiter taps "Masaya Ekle" and the screen goes back to a blank cart. That
 * blankness is the same thing an accidental clear looks like, so they tap
 * again, and the table gets the round twice. This is the difference between
 * "it worked" and "did it work?".
 *
 * Two seconds: long enough to read at arm's length, short enough that nobody
 * waits for it before taking the next order.
 */
export function Toast({ message, tone = 'ok', onDone }: Props) {
  useEffect(() => {
    const t = window.setTimeout(onDone, 2000)
    return () => window.clearTimeout(t)
    // Keyed by message at the call site, so a second save restarts the clock
    // rather than inheriting what is left of the first one's.
  }, [message, onDone])

  return (
    <div className={`toast toast--${tone}`} role="status" aria-live="polite">
      {message}
    </div>
  )
}
